import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {actions} from '../../actions';

import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {BASENAME} from "../../constants";

const RUBRICS_HEADER_ROW = ["Criteria", "Ratings", "Pts"];

const stylesCard = theme => ({
    card: {
        padding: 0,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginLeft: '5px',
        marginRight: '5px',
        height: "100%"
    },
    cardActionArea: {
        height: "100%",
        padding: 0
    },
    cardContent: {
        padding: 0
    },
    cardSelected: {
        backgroundColor: "#CCC"
    },
    cardDefault: {
        backgroundColor: "#FFF"
    },
});

class RadioCard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {rating, classes, selected} = this.props;
        const selectionClass = selected ? classes.cardSelected : classes.cardDefault;
        if(rating.na){
            return (
                <Card className={classNames([classes.card, selectionClass])}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="subtitle1" gutterBottom>
                            {rating.rating_title}
                        </Typography>
                        <Typography variant="body3">
                            {rating.rating_description}
                        </Typography>
                        <Typography variant="subtitle2">
                            Pts: N/A
                        </Typography>
                    </CardContent>
                </Card>
            );
        } else {
            return (
                <Card className={classNames([classes.card, selectionClass])}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="subtitle1" gutterBottom>
                            {rating.rating_title}
                        </Typography>
                        <Typography variant="body3">
                            {rating.rating_description}
                        </Typography>
                        <Typography variant="subtitle2">
                            Pts: {rating.points}
                        </Typography>
                    </CardContent>
                </Card>
            );
        }
    }
}

const RadioCardWithStyles = withStyles(stylesCard)(RadioCard);

const stylesRubricRate = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
        flexGrow: 1
    },
    table: {
        // minWidth: 700,
        // tableLayout: 'auto'
        // padding: "none"
    },
    cell: {
        // width: "auto"
        padding: theme.spacing.unit
    },
    grid: {
        padding: 0
    },
    button: {
        margin: theme.spacing.unit,
    }
});

class RubricRate extends Component {
    constructor(props) {
        super(props);
        const reviewer = this.props.reviewers.find(reviewer => reviewer.unid === this.props.user.unid);
        const scores = reviewer.artifactScores.find(artifactScore => artifactScore.artifact_id === this.props.artifactId).rubricScores;
        this.state = {
            scores,
            reviewer
        };
    }

    handleRatingSelection = (rubricIndex, points) => (e) => {
        // console.log("rubricIndex, points", rubricIndex + ", " + points);
        const scores = this.state.scores;
        scores[rubricIndex] = points;
        this.setState({scores});
    };

    isRatingSelected = (rubricIndex, points) => {
        return points === this.state.scores[rubricIndex];
    };

    handleSaveScoreToDB = async () => {
        // update scores
        const assessment_id = this.props.form._id;
        const reviewer_unid = this.state.reviewer.unid;
        const artifact_id = this.props.artifactId;
        // console.log("this.state.scores: ", this.state.scores);
        let updatedAssessment = await fetch(
            BASENAME + '/api/rubrics/' + assessment_id + "/" + reviewer_unid + "/" + artifact_id,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(this.state.scores)
            }
        );
        // console.log("handleSaveScoreToDB updatedAssessment: ", updatedAssessment);

        // update Redux (is this necessary?)
        this.saveScoreToRedux();

        // close drawer
        this.props.onCancel();
    };

    saveScoreToRedux = () => {
        const updatedReviewer = {...this.state.reviewer};
        // update scores
        updatedReviewer.artifactScores.find(artifactScore => artifactScore.artifact_id === this.props.artifactId).rubricScores = this.state.scores;
        // update finished
        updatedReviewer.finished = !updatedReviewer.artifactScores.find(artifactScore => artifactScore.rubricScores.includes(-1));
        // console.log("RubricRate updatedReviewer: ", updatedReviewer);
        this.props.updateReviewer(updatedReviewer);
        // close drawer
        this.props.onCancel();
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    renderHeaderRow = () => (
        <TableRow>
            {RUBRICS_HEADER_ROW.map(item => (
                    <TableCell align="center" className={this.props.classes.cell}>
                        <Typography variant="subtitle1">{item}</Typography>
                    </TableCell>
                )
            )}
        </TableRow>
    );

    renderRubricRows = (rubrics) => {
        return rubrics.map((rubric, rubricIndex) => {
            const mappedCells = rubric.ratings.map((rating, ratingIndex) => {
                return (
                    <Grid item xs className={this.props.classes.grid}
                          onClick={this.handleRatingSelection(rubricIndex, rating.points)}>
                        <RadioCardWithStyles rating={rating} rubricIndex={ratingIndex} selected={this.isRatingSelected(rubricIndex, rating.points)}/>
                    </Grid>
                );
            });

            return (
                <TableRow key={rubricIndex}>
                    <TableCell component="th" scope="row" align="center" className={this.props.classes.cell}>
                        <Typography variant="subtitle1" gutterBottom>
                            {rubric.criteria_title}
                        </Typography>
                    </TableCell>
                    <TableCell align="center" className={this.props.classes.cell}>
                        <Grid container spacing={24}>{mappedCells}</Grid>
                    </TableCell>
                    <TableCell align="center" className={this.props.classes.cell}>
                        <Typography variant="subtitle1">
                            {this.state.scores[rubricIndex] < 0 ? "N/A" : this.state.scores[rubricIndex]}
                        </Typography>
                    </TableCell>
                </TableRow>
            );
        });
    };

    render() {
        return (
            <Paper className={this.props.classes.root}>
                <Table className={this.props.classes.table}>
                    <TableHead>
                        {this.renderHeaderRow()}
                    </TableHead>
                    <TableBody>
                        {this.renderRubricRows(this.props.rubrics)}
                    </TableBody>
                </Table>
                <div align="center">
                    <Button variant="contained" className={this.props.classes.button} onClick={this.handleCancel}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="secondary" className={this.props.classes.button} onClick={this.handleSaveScoreToDB}>
                        Save
                    </Button>
                </div>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return {
        reviewers: state.reviewers,
        user: state.user,
        rubrics: state.rubrics,
        form: state.newAssessmentForm
    }
}

export default connect(mapStateToProps, actions)(withStyles(stylesRubricRate)(RubricRate));
